import ErrorService from "vamos/cockpit/base/services/type/ErrorService";
import ApiService from "vamos/cockpit/base/services/type/ApiService";
import getText from "vamos/cockpit/base/handler/Text";

export default class ApiFileHandler {


  public static async downloadFileFromApi(endPoint: string, payload: any, fileName: string, extension: string): Promise<void> {

    const appResponse = await ApiService.getInstance().postJsonWithoutChecks(endPoint, payload);

    if (appResponse.success) {
      const blob: Blob = await appResponse.data.blob();
      this.handleDownloadWarnings(appResponse.data);
      this.handleFileResponse(blob, fileName, extension);
    } else {
      ErrorService.getInstance().showErrorMessageBox(getText("ErrorDuringFileDownload"));
    }
  }


  private static handleFileResponse(blob: Blob, fileName: string, extension: string): void {
    const url: string = window.URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement("a");
    a.href = url;
    a.download = fileName + "." + extension;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  private static handleDownloadWarnings(response: any): void {
    const downloadWarnings = response.headers.entries().find(([key]: string) => key.toLowerCase() === "download-warnings") as string;
    if (downloadWarnings) {
      const warnings = JSON.parse(downloadWarnings[1]) as string[];

      const warning = warnings.join("\n");

      ErrorService.getInstance().showErrorMessageBox(warning);
    }
  }
}
